<template>
<div class="wrap">
    <div class="swiper-container subPage-mobile-menu">
        <div class="swiper-wrapper">
            <div class="swiper-slide" :class="{'active': ($route.path.indexOf(pItem.subLink) !== -1) && ($route.query.name.indexOf(pItem.subName) !== -1)}"  v-for="(pItem,pIdx) in pcSubPageMenu" :key="pIdx" @click="tabMenu(pItem)">
                {{pItem.subName}}
            </div>
        </div>
    </div>
</div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
export default {
    data () {
        return {}
    },
    props: {
        pcSubPageMenu: Array,
        mIndex: {
            type: Number,
            default: 0
        }
    },
    mounted() {
        let swiperCenter = false;
        var newsSwiper = new Swiper ('.subPage-mobile-menu', {
            slidesPerView:  3.7,
            grabCursor : true,
            freeMode : true,
            slideToClickedSlide: true,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
        })
    },
    methods:{
        tabMenu(pItem){
            this.$emit('subpagemenu',pItem)
        }
    }
}
</script>
<style lang="less" scoped>
@import "../../../static/function.less";
.subPage-mobile-menu{
    display: none;
    span{}
    border: 1px solid #e4e4e4;
    min-height: 40px;
    .swiper-slide{
        position: relative;
        font-size: @font14;
        padding: 8px 5px;
        text-align: center;
        .flexcontentitems(center, center);
        height: auto;
        &.active{
            color:#ea0e1e;
            border-bottom: 3px solid;
        }
        &:after{
            content: '|';
            position: absolute;
            right: -7%;
            top: 50%;
            transform:translate(-50%,-50%);
            font-size: 20px;
            color: #e4e4e4;
        }
    }
}
@media (min-width: 320px) and (max-width: 767px){
    .subPage-mobile-menu{
        display: block;
    }
    .wrap{
        margin-top: 0px;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/subMenuBarSpa/subMenuBar.vue